import { AxiosError } from 'axios'
import BaseService from '@/services/baseService'
import {
  AttemptListParams,
  AttemptListResponse,
  AttemptResultDetail,
} from '@/types/attempt'

class AttemptService extends BaseService {
  async getAttemptList(
    params: AttemptListParams
  ): Promise<AttemptListResponse> {
    try {
      const response = await this.get<AttemptListResponse>(
        '/attempt/list',
        params
      )
      return response
    } catch (error) {
      if (error instanceof AxiosError && error.response?.data) {
        throw new Error(
          error.response.data.message || 'Failed to fetch attempt list'
        )
      }
      throw error
    }
  }

  async getAttemptResult(attempt_id: number): Promise<AttemptResultDetail> {
    try {
      const response = await this.get<AttemptResultDetail>(
        `/attempt/${attempt_id}`
      )
      return response
    } catch (error) {
      if (error instanceof AxiosError && error.response?.data) {
        throw new Error(
          error.response.data.message || 'Failed to fetch attempt result'
        )
      }
      throw error
    }
  }
}

export const attemptService = new AttemptService()
